import { Suspense, useEffect, useState } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import SEO, { breadcrumb } from "@/components/SEO";
import { lazyWithRetry } from "@/lib/lazyWithRetry";

const ServicesSection = lazyWithRetry(() => import("@/components/ServicesSection"));
const CaseTeaserSection = lazyWithRetry(() => import("@/components/CaseTeaserSection"));
const FreeOfferSection = lazyWithRetry(() => import("@/components/ProjectsSection"));
const PriceTeaserSection = lazyWithRetry(() => import("@/components/PriceTeaserSection"));
const ContactSection = lazyWithRetry(() => import("@/components/ContactSection"));
const Footer = lazyWithRetry(() => import("@/components/Footer"));

const Index = () => {
  // Defer mounting below-the-fold sections until the browser is idle
  // so the hero can paint (LCP) without competing for the main thread.
  const [showRest, setShowRest] = useState(false);

  useEffect(() => {
    const w = window as Window & { requestIdleCallback?: (cb: () => void) => number };
    const schedule = w.requestIdleCallback ?? ((cb: () => void) => setTimeout(cb, 200));
    const id = schedule(() => setShowRest(true));
    return () => {
      if (typeof id === "number") clearTimeout(id);
    };
  }, []);

  return (
    <main className="min-h-screen bg-background" style={{ overflowX: "clip" }}>
      <SEO
        title="Vikra Group | Webbyrå i Norge – Moderne nettsider på én uke"
        description="Norsk webbyrå som leverer moderne, raske nettsider på én uke. Webdesign, utvikling, SEO og vedlikehold for bedrifter i hele Norge."
        path="/"
        jsonLd={breadcrumb([{ name: "Hjem", path: "/" }])}
      />
      <Navigation />
      <HeroSection />

      {showRest && (
        <Suspense fallback={null}>
          <ServicesSection />
          <PriceTeaserSection />
          <CaseTeaserSection />
          <FreeOfferSection />
          <ContactSection />
          <Footer />
        </Suspense>
      )}
    </main>
  );
};

export default Index;
